import PropTypes from 'prop-types';
import React from 'react';
import styleHelper from '@client/shared/styles/styleHelper.scss';
import styles from './formSectionTitle.scss';

function FormSectionTitle({ className, digit, headerText, headerComment }) {
  return (
    <div
      className={`${styles.formSectionTitle}${
        className ? ` ${className}` : ''
      }`}
    >
      <h3 className={`${styleHelper.titleMdPrimary} ${styles.title}`}>
        {`${digit ? `${digit}. ` : ''} ${headerText}`}
      </h3>
      <span className={styles.titleComment}>{headerComment}</span>
    </div>
  );
}

FormSectionTitle.propTypes = {
  className: PropTypes.string,
  digit: PropTypes.number,
  headerText: PropTypes.string,
  headerComment: PropTypes.string,
};

export default FormSectionTitle;
